import React, { useEffect, useRef, useState } from 'react';
import NewGameState from '../../_types/NewGameState';
import { ViewContainer } from './GameImage.styles';
import styled from '@emotion/styled';
import { GamifyIcon } from '../../../../../components/GamifyIcon';
import {
  AddButton,
  ContestantPill,
  CustomInputLabel,
} from '../../custom-inputs/CustomInputs.styles';

const ImageUploadContainer = styled.div<{ theme?: any }>`
  background-color: ${({ theme }) => theme?.custom?.background1 || 'white'};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme?.custom?.stroke || '#e0e0e0'};
`;

interface Props {
  newGameState: NewGameState;
  onChangeNewGameState: (newGameState: NewGameState) => void;
}

const GameImageView: React.FC<Props> = ({
  newGameState,
  onChangeNewGameState,
}) => {
  const uploadRef = useRef<any>();
  const [filePreview, setFilePreview] = useState<any>(null);

  const onUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    console.log('files', files);
    if (files && files.length > 0) {
      try {
        const selectedFile = files[0];
        const filePreview = URL.createObjectURL(selectedFile);

        onChangeNewGameState({
          ...newGameState,
          imageType: 'image',
          imageName: selectedFile.name,
          imageFile: selectedFile,
        });

        setFilePreview(filePreview);
      } catch (error) {}
    }
  };

  useEffect(() => {
    if (newGameState.imageFile) {
      const filePreview = URL.createObjectURL(newGameState.imageFile);
      setFilePreview(filePreview);
    }
  }, []);

  const triggerFileSelection = () => {
    if (uploadRef.current) {
      uploadRef.current.click();
    }
  };

  return (
    <ViewContainer>
      {/* New UI */}
      <CustomInputLabel>Game Image</CustomInputLabel>

      <ImageUploadContainer>
        <ContestantPill
          backgroundColor="#FF8A65"
          onClick={triggerFileSelection}
        >
          <AddButton>
            <GamifyIcon icon="add" color="white" height={16} width={16} />
            Add
          </AddButton>
        </ContestantPill>

        <input
          onChange={(e) => onUpload(e)}
          style={{ display: 'none' }}
          accept="image/*"
          type="file"
          ref={(ref) => (uploadRef.current = ref)}
        />

        {filePreview && (
          <div
            style={{
              marginLeft: '12px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img
              src={filePreview}
              alt="Preview"
              style={{
                height: '32px',
                width: 'auto',
                marginRight: '8px',
                borderRadius: '4px',
              }}
            />
            <span style={{ fontSize: '13px', color: '#333' }}>
              {newGameState.imageName}
            </span>
          </div>
        )}
      </ImageUploadContainer>
    </ViewContainer>
  );
};

export default GameImageView;
